import { Injectable } from '@angular/core';
import { RequestOptions, URLSearchParams} from '@angular/http';
import { ToastrService } from 'ngx-toastr';

import { CommonRequestService } from './common-request.service';
import { UserService } from './user.service';
import { AppSettings } from './../app.settings';

export interface Project {
	projId: number;
	name: string;
	desc: string;
	isDefault: boolean;
	isDeleted: boolean;
	module: string; // e.g. 'LBE'
}

@Injectable()
export class ProjectService {

	constructor(
		private toastr: ToastrService,
		private requestService: CommonRequestService,
		private userService: UserService
	) { }

	getProjectsByApp(appName: string): Promise<Project[]> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/project';
			const params = new URLSearchParams();
			const options = new RequestOptions();
			params.set('customerId', this.userService.getUserInfo().customerId.toString());
			params.set('application', appName);
			options.params = params;
			this.requestService.requestGet(url, options, (rsp) => {
				const projects = this.handleGetProjects(rsp);
				resolve(projects);
			}, (err) => {
				reject();
			});
		});
	}
	// Handle rsp for getProjects and getProjectInfo
	private handleGetProjects(rsp): Project[] {
		const projects: Project[] = [];
		if (rsp.data) {
			rsp.data.forEach((item) => {
				projects.push({
					projId: item.prj_id,
					name: item.prj_name,
					desc: item.prj_desc,
					isDefault: item.prj_default,
					isDeleted: item.prj_deleted,
					module: item.prj_mod_cd
				});
			});
		}
		return projects;
	}
	// Add a project to the provided userSub's application
	createProject(name: string, desc: string, userSubId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/project';
			const body = {
				projectName: name,
				projectDescription: desc,
				userSubscriptionId: userSubId
			};
			this.requestService.requestPost(url, body, () => {
				resolve();
			}, () => {
				reject();
			});
		});
	}

	// getProjectInfo(projectId, successCallback?, errorCallback?) {
	// 	const url = AppSettings.serviceRootUrl + 'admin/project';
	// 	const params = new URLSearchParams();
	// 	const options = new RequestOptions();
	// 	// params.set('subscriptionId', this.userService.getUserInfo().subscriptionId);
	// 	params.set('projectId', projectId);
	// 	params.set('customerId', this.userService.getUserInfo().customerId);
	// 	params.set('application', AppSettings.appName);
	// 	options.params = params;
	// 	this.requestService.requestGet(url, options, (rsp) => {
	// 		if (successCallback) {
	// 			const info = this.handleGetProjects(rsp)[0];
	// 			successCallback(info);
	// 		}
	// 	}, errorCallback);
	// }

	// // Set current project
	// setCurrentProj() {
	// 	let currProject: Project;
	// 	const projects = this.projects.getValue();
	// 	if (!projects[0]) {
	// 		alert('No Project exist!!!!!!!!!!!!!!');
	// 		return;
	// 	}
	// 	// Check if there is default project
	// 	currProject = projects.find((p) => {
	// 		return p.isDefault && !p.isDeleted;
	// 	});
	// 	if (!currProject) {
	// 		currProject = projects.find((p) => {
	// 			return !p.isDeleted;
	// 		});
	// 	}
	// 	// // Set first project as current if no default project exists
	// 	// currProject = currProject || projects[0];
	// 	this.currentProject.next({
	// 		projId: currProject.projId
	// 	});
	// 	console.log('Current Project: ' + currProject.projId);
	// }
	// //
	// alertProjectChange(projName, isPrevProject?) {
	// 	const message = isPrevProject ? 'Current project switched to ' + projName : 'Current Project: ' + projName;
	// 	this.toastr.info(message);
	// }

	// // Update a project
	// updateProject(projectId, properties: {name?: string, desc?: string, isDefault?: boolean}, successCallback?, errorCallback?) {
	// 	const url = AppSettings.serviceRootUrl + 'admin/project';
	// 	const body = {
	// 		projectId: projectId,
	// 		application: AppSettings.appName
	// 		// subscriptionId: this.userService.getUserInfo().subscriptionId.toString()
	// 	};
	// 	const match = {
	// 		name: 'projectName',
	// 		desc: 'projectDescription',
	// 		isDefault: 'default'

	// 	};
	// 	for (const prop of Object.keys(properties)) {
	// 		body[match[prop]] = properties[prop];
	// 	}
	// 	this.requestService.requestPut(url, body, (rsp) => {
	// 		// If isDefault is changed, the rest of projects also need to be updated
	// 		if (properties.hasOwnProperty('isDefault')) {
	// 			this.getProjects((projects) => {
	// 				this.toastr.success('Project has been updated succesfully!');
	// 				if (successCallback) { successCallback(projects); }
	// 			}, errorCallback, true);
	// 		} else { // If only name / desc is changed, the rest of projects don't need to be updated
	// 			const list = this.projects.getValue();
	// 			this.getProjectInfo(projectId, (updatedProject) => {
	// 				const projectIndex = list.findIndex((p) => {
	// 					return p.projId === projectId;
	// 				});
	// 				list[projectIndex] = updatedProject;
	// 				this.projects.next(list);
	// 				this.toastr.success('Project has been updated succesfully!');
	// 				if (successCallback) {
	// 					successCallback(rsp);
	// 				}
	// 			}, errorCallback);
	// 		}
	// 	}, errorCallback);
	// }
	// // Add a project
	// createProject(name, desc, successCallback?, errorCallback?) {
	// 	const url = AppSettings.serviceRootUrl + 'admin/project';
	// 	const body = {
	// 		projectName: name,
	// 		projectDescription: desc,
	// 		userSubscriptionId: this.userService.getUserInfo().userSubId.toString()
	// 	};
	// 	this.requestService.requestPost(url, body, (rsp) => {
	// 		this.getProjects(successCallback, errorCallback, true);
	// 	}, errorCallback);
	// }
	// // Delete a project
	// deleteProject(projectId, successCallback?, errorCallback?) {
	// 	const url = AppSettings.serviceRootUrl + 'admin/project';
	// 	const body = {
	// 		projectId: projectId,
	// 		// userId: this.userService.getUserInfo().userId,
	// 		userSubscriptionId: this.userService.getUserInfo().userSubId
	// 	};
	// 	const options = new RequestOptions({
	// 		body: body
	// 	});
	// 	this.requestService.requestDelete(url, options, (rsp) => {
	// 		this.getProjects(successCallback, errorCallback, true);
	// 	}, errorCallback);
	// }
}



// WEBPACK FOOTER //
// ./src/app/common-services/project.service.ts